import { useState, useRef } from 'react';
import { useOutletContext } from 'react-router';
import Timer from './timer';
import Home from './home';
import MyRoutine from './myRoutine';
import PastRoutine from './pastRoutine';
import AICoach from './aiCoach';
import OpenChat from './openChat';
import Application from './application';
import WeightProgress from '../../main/dashboard/weightProgress';
import BodyProgress from '../../main/dashboard/bodyProgress';
import MeasurementProgress from '../../main/dashboard/measurementProgress';
import Title from '../../../components/dialog/title';

const HUBS = {
  HOME: 'HOME',
  PROGRAM: 'PROGRAM',
  COACH: 'COACH',
  FEEDBACK: 'FEEDBACK',
  TIMER: 'TIMER',
  CHECK_IN: 'CHECK_IN',
  ROUTINE: 'ROUTINE',
  PAST_ROUTINE: 'PAST_ROUTINE',
  AI_COACH: 'AI_COACH',
  OPEN_CHAT: 'OPEN_CHAT',
  APPLICATION: 'APPLICATION',
  WEIGHT_PROGRESS: 'WEIGHT_PROGRESS',
  BODY_PROGRESS: 'BODY_PROGRESS',
  MEASUREMENT_PROGRESS: 'MEASUREMENT_PROGRESS',
};

const HUB_TITLES = {
  [HUBS.HOME]: 'Coaching Hub',
  [HUBS.TIMER]: 'Workout Timer',
  [HUBS.PROGRAM]: 'My Routine',
  [HUBS.COACH]: 'Consult Your Coach',
  [HUBS.FEEDBACK]: 'Coach Feedback',
  [HUBS.CHECK_IN]: 'Weekly Check-ins',
  [HUBS.ROUTINE]: 'My Routine',
  [HUBS.PAST_ROUTINE]: 'Past Routine',
  [HUBS.AI_COACH]: 'AI Coach',
  [HUBS.OPEN_CHAT]: 'Open Chat',
  [HUBS.APPLICATION]: 'Application',
  [HUBS.WEIGHT_PROGRESS]: 'Weight Log',
  [HUBS.BODY_PROGRESS]: 'Body Log',
  [HUBS.MEASUREMENT_PROGRESS]: 'Measurement Log',
};

const Hub = () => {
  const { user } = useOutletContext();

  const aiCoachDialogRef = useRef(null);

  const [currentHub, setCurrentHub] = useState(HUBS.HOME);

  const handleHubChange = (hub) => {
    setCurrentHub(hub);
  };

  const openAiCoachDialog = () => {
    if (aiCoachDialogRef.current) {
      aiCoachDialogRef.current.showModal();
    }
  };

  const closeAiCoachDialog = () => {
    if (aiCoachDialogRef.current) {
      aiCoachDialogRef.current.close();
    }
  };

  return (
    <div className='pb-24 p-4'>
      {currentHub === HUBS.HOME ? (
        <h1 className='text-2xl font-bold mb-4 text-white'>
          {HUB_TITLES[currentHub]}
        </h1>
      ) : (
        currentHub !== HUBS.AI_COACH && (
          <Title
            title={HUB_TITLES[currentHub]}
            onClick={() => handleHubChange(HUBS.HOME)}
            color='white'
          />
        )
      )}
      {currentHub === HUBS.HOME && (
        <Home
          handleHubChange={handleHubChange}
          openAiCoachDialog={openAiCoachDialog}
        />
      )}
      {currentHub === HUBS.TIMER && <Timer />}
      {currentHub === HUBS.ROUTINE && <MyRoutine />}
      {currentHub === HUBS.PAST_ROUTINE && <PastRoutine />}
      {currentHub === HUBS.OPEN_CHAT && <OpenChat />}
      {currentHub === HUBS.APPLICATION && <Application />}
      {currentHub === HUBS.WEIGHT_PROGRESS && <WeightProgress />}
      {currentHub === HUBS.BODY_PROGRESS && <BodyProgress />}
      {currentHub === HUBS.MEASUREMENT_PROGRESS && <MeasurementProgress />}
      {/* <AICoach
        aiCoachDialogRef={aiCoachDialogRef}
        user={user}
        closeAiCoachDialog={closeAiCoachDialog}
      /> */}
    </div>
  );
};

export default Hub;
